import { render, staticRenderFns } from "./VehicleContracts.vue?vue&type=template&id=9882e468&scoped=true"
import script from "./VehicleContracts.vue?vue&type=script&lang=ts"
export * from "./VehicleContracts.vue?vue&type=script&lang=ts"
import style0 from "./VehicleContracts.vue?vue&type=style&index=0&id=9882e468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9882e468",
  null
  
)

export default component.exports